import React, { useState } from 'react'
import { Spinner } from 'react-bootstrap'
import TrackedLinksTableRecord from './TrackedLinksTableRecord'
import './TrackedLinksTable.css'

const TrackedLinksTable = ({ trackedLinks, isLoadingLinks, onDelete }) => {
  const [animatingLinks, setAnimatingLinks] = useState(new Set())

  const handleDelete = async (linkLabel) => {
    setAnimatingLinks((prev) => new Set([...prev, linkLabel]))
    try {
      await onDelete(linkLabel)
    } finally {
      setAnimatingLinks((prev) => {
        const next = new Set(prev)
        next.delete(linkLabel)
        return next
      })
    }
  }

  if (isLoadingLinks) {
    return (
      <div className="text-center">
        <Spinner animation="border" size="sm" />
      </div>
    )
  }

  if (trackedLinks.length === 0) {
    return <p className="text-muted">You haven't created any tracked links yet.</p>
  }

  return (
    <div className="tracked-links-table d-flex flex-column">
      {trackedLinks.map((link) => (
        <TrackedLinksTableRecord
          key={link.label}
          link={link}
          onDelete={handleDelete}
          className={`${link._entering ? 'entering' : ''} ${link._exiting ? 'exiting' : ''}`}
          isAnimating={animatingLinks.has(link.label)}
        />
      ))}
    </div>
  )
}

export default TrackedLinksTable
